import React, { useState } from 'react'
import { Box, Typography, Icon } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import ACMatchingDataChip from './ACMatchingDataChip'
import ACMatchingDataTable from './ACMatchingDataTable'
import AdxButton from 'components/custom/AdxButton'

const ACMatchingTable = ({
  getMatchingData,
  setShowMatchingTable,
  setCompleteUploadMatching,
  showMatchingTable,
  setStaffData,
  staffData,
  setUpload,
  matchingLoading,
}) => {
  const [pageState, setPageState] = useState('IMPORT')
  const showStuffData = getMatchingData?.participant
  const validateData = getMatchingData?.reviewer_count - getMatchingData?.errors_count
  setStaffData(getMatchingData?.participant)

  const handleReuploadCSV = () => {
    setUpload(false)
    setCompleteUploadMatching(false)
    setShowMatchingTable(false)
  }

  const handleConfirm = () => {
    let newValues = {
      participant: staffData,
    }
    setStaffData(newValues)
    setCompleteUploadMatching(true)
    setShowMatchingTable(false)
  }

  const CustomHeader = () => {
    return (
      <>
        <Box
          sx={{
            py: 1,
            px: 4,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 1,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Icon sx={{ color: 'alternate.main', mr: 1, fontSize: 28 }}>groups</Icon>
            <Typography variant="h4">Matching Results</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}></Box>
        </Box>
      </>
    )
  }

  return (
    <AdxFormModal
      open={showMatchingTable}
      disableEscapeKeyDown
      disableAutoFocus={true}
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
        paddingY: '20px',
      }}
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '1000px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 1500px)' },
      }}
      customHeader={<CustomHeader />}
    >
      <>
        {pageState === 'IMPORT' && (
          <Box
            sx={{
              width: '100%',
              minHeight: '300px',

              display: 'flex',
              flexDirection: 'column',
              rowGap: 2,
            }}
          >
            {/* Header */}
            <Box
              sx={{
                width: 1,

                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography mr={1} variant="body2" color="light-gray-text.main">
                  Check the details uploaded and click Confirm.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'flex-start',
                  rowGap: 0.5,
                }}
              >
                <ACMatchingDataChip
                  sx={{ mr: 2 }}
                  color="info.main"
                  content={`${getMatchingData?.reviewer_count} data found`}
                />
                <ACMatchingDataChip
                  color="error.main"
                  content={`${getMatchingData?.errors_count} ${
                    getMatchingData?.errors_count > 1 ? 'errors' : 'error'
                  } found`}
                />
              </Box>
            </Box>
            {/* Table */}
            <Box>
              {/* Table Header*/}
              <Box
                sx={{
                  width: '100%',
                  height: '45px',
                  backgroundColor: 'gray-background.main',
                  display: 'flex',
                  py: 1,
                  px: 3,
                  alignItems: 'center',
                  overflow: 'auto',
                }}
              >
                <Box sx={{ minWidth: '150px' }} width={1 / 4}>
                  <Typography align="center" variant="body1" color="dark-gray-text.main">
                    Reviewer Name
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px' }} width={1 / 4}>
                  <Typography align="center" variant="body1" color="dark-gray-text.main">
                    Reviewer Email
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px' }} width={1 / 4}>
                  <Typography align="center" variant="body1" color="dark-gray-text.main">
                    Reviewee Name
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px' }} width={1 / 4}>
                  <Typography align="center" variant="body1" color="dark-gray-text.main">
                    Reviewee Email
                  </Typography>
                </Box>
              </Box>
              {/* Table Data*/}
              <Box>
                <ACMatchingDataTable
                  showStuffData={showStuffData}
                  matchingLoading={matchingLoading}
                />
              </Box>
            </Box>
            {/* Footer */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                flexDirection: 'row',
                alignItems: 'center',

                width: '100%',
                height: '50px',
                columnGap: 1,
              }}
            >
              <AdxButton variant={'outlined'} onClick={handleReuploadCSV} sx={{ width: '100px' }}>
                Cancel
              </AdxButton>
              <AdxButton
                variant={'contained'}
                onClick={handleConfirm}
                sx={{ width: '200px' }}
                disabled={
                  staffData && validateData === getMatchingData?.reviewer_count && !matchingLoading
                    ? false
                    : true
                }
              >
                Confirm
              </AdxButton>
            </Box>
          </Box>
        )}
      </>
    </AdxFormModal>
  )
}

export default ACMatchingTable
